<template>
  <div style="padding-right: 34px;">
    <v-overlay
      v-model="showSuccess"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9998"
    >
    </v-overlay>
    
    <!-- Success Toast -->
    <transition name="fade-slide">
      <div v-if="showSuccess" class="success-toast" role="status" style="position: fixed; top: 30px; left: 50%; transform: translateX(-50%); z-index: 9999;">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 14px; font-weight: 600;">{{ SuccessMessage }}</span>
      </div>
    </transition>

    <v-container fluid class="border mt-4 mx-5" style="border-radius: 16px; padding: 24px; margin-bottom: 24px;">
        <v-toolbar class="bg-white subTitleStyle">
          <v-toolbar-title class="text-black ms-0" style="font-size: 1.3rem;">{{
            $t("_BlacklistChatUserManagement")
          }}</v-toolbar-title>
          <div class="d-flex flex-wrap" style="gap:24px;">
            <v-text-field
            id="id-field-search-blacklist"
            :placeholder="$t('_userid')"
            class="searchInput"
            density="comfortable"
            variant="outlined"
            hide-details
            v-model="userID"
            @keydown.enter="Search"
            color="primary"
          >
            <img src="@/assets/Icons/new_search_outline.svg" alt="Search" class="mr-2">
          </v-text-field>
          <v-btn
            id="button-add-blacklist"
            color="primary"
            class="control-btn create-btn"
            variant="elevated"
            size="large"
            rounded="xl"
            @click="Adddialog = true"
          >
            <img src="@/assets/Icons/new_round_plus.svg" alt="">
            <span class="btn-text">{{ $t("add") }}</span>
            <v-tooltip activator="parent" location="top">
              {{ $t("addNewUser") }}
            </v-tooltip>
          </v-btn>
          </div>
        </v-toolbar>

      <!-- <v-card class="card2 pa-0" style="margin-top: 1rem; border-radius: 16px !important;"> -->
        <!-- <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-rowtable-dataIntegration"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      {{  $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              
            </v-col>
          </v-row>
        </v-card-text> -->
        <v-data-table-server
          :items="userList"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :headers="headers"
          class="mt-5"
        >
          <!-- No Data Template -->
          <template v-slot:no-data>
            <div class="no-data-placeholder" :style="!userID ? { color: 'grey' } : {}"><span style="color: grey">{{ userID ? 'Searching ' : '' }}</span>{{ noDataMessage }}</div>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td class="table-cell">{{ item.number }}</td>
              <td class="table-cell">{{ item.userID }}</td>
              <td class="table-cell">{{ toLocal(item.createDate) }}</td>
              <td style="text-align: center">
                <!-- Delete Button -->
                <v-btn
                  id="button-delete-blacklist"
                  variant="text"
                  density="comfortable"
                  @click="openDeleteDialog(item)"
                  class="action-btn delete-btn"
                  icon
                >
                  <img src="@/assets/Icons/new_delete.png" alt="">
                  <v-tooltip activator="parent" location="top">
                    Delete
                  </v-tooltip>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4"
              style="width: 100%; margin-top: 24px;"
            >
              <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]"
                class="pa-0"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      <!-- </v-card> -->
    </v-container>

    <!-- AddUserDialog -->
    <v-dialog
      v-model="Adddialog"
      max-width="900px"
      @click:outside="clearFields"
      transition="dialog-bottom-transition"
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header">
            <div class="header-text-content">
              <h2 class="dialog-title">Add To Blacklist</h2>
              <p class="dialog-subtitle">Select users to add to the blacklist</p>
            </div>
        </div>

        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="input-section"  style="border-radius: 24px !important;">
            <div class="input-label">
              <img src="@/assets/Icons/new_user_block.png" alt="user" class="mr-2"/>
              <span style="font-weight: 600; font-size: 20px;">Blacklist User</span>
              <span class="required-asterisk">*</span>
            </div>
            <label>Select Line Users
              <v-tooltip location="top start">
                Selected users will be restricted from chat functionality.
                <template #activator="{ props }">
                  <v-icon
                    v-bind="props"
                    size="20"
                    class="info-icon"
                    color="grey"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
              </v-tooltip>
            </label>
          <v-autocomplete
            id="lineuser-autocomplete-blacklist"
            :placeholder="isFocused ? 'Type to search users...' : 'Search and select users'"
            :items="allUsersOptions"
            chips
            :closable-chips="allUsersSelected ? false : true"
            item-title="userId"
            item-value="userId"
            multiple
            v-model="LineUserID"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="modern-autocomplete mt-2"
            :rules="[v => v && v.length > 0 || 'Please select at least one user' ]"
            @focus="isFocused = true"
            @blur="isFocused = false"
          >
              <template v-slot:chip="{ props, item }">
                <v-chip
                  v-if="allUsersSelected && item.raw.userId === LineUserID[0]"
                  v-bind="props"
                  text="All Users"
                  color="error"
                  variant="tonal"
                  size="small"
                  class="user-chip"
                  close="false"
                  style="background: white !important;"
                >
                  All Users
                  <v-tooltip location="top start">
                    All users will be restricted from chat functionality.
                    <template #activator="{ props }">
                      <v-icon
                        v-bind="props"
                        size="20"
                        class="info-icon ml-1"
                        color="grey"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                  </v-tooltip>
                </v-chip>
                <v-chip
                  v-else-if="!allUsersSelected"
                  v-bind="props"
                  :text="item.raw.userId"
                  color="error"
                  variant="tonal"
                  size="small"
                  closable
                  class="user-chip"
                >
                </v-chip>
              </template>
              
              <template v-slot:prepend-item>
                <v-list-item
                  @click="toggleAllUsers"
                  class="all-users-item"
                  :class="{ 'selected': allUsersSelected }"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn
                      :model-value="allUsersSelected"
                      :indeterminate="someUsersSelected"
                      color="error"
                    ></v-checkbox-btn>
                  </template>
                  <v-list-item-title class="">
                    All Users
                    <v-tooltip location="top start">
                      All users will be restricted from chat functionality.
                      <template #activator="{ props }">
                        <v-icon
                          v-bind="props"
                          size="20"
                          class="info-icon"
                          color="grey"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </v-list-item-title>
                </v-list-item>
              </template>
              
              <template v-slot:item="{ props, item, index }">
                <v-list-item
                  :id="'lineuser-option-' + index" 
                  :value="item.raw.userId"
                  class="autocomplete-item"
                  @click="toggleUser(item.raw.userId)"
                >
                  <template v-slot:prepend>
                    <v-checkbox-btn
                      :model-value="LineUserID.includes(item.raw.userId)"
                      color="error"
                    ></v-checkbox-btn>
                  </template>
                  
                  <v-list-item-title>{{ item.raw.userId }}</v-list-item-title>
                  <v-list-item-subtitle v-if="item.raw.displayName" style="height: 20px;">
                    {{ item.raw.displayName }}
                  </v-list-item-subtitle>
                </v-list-item>
              </template>
              
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title class="text-grey">
                    No users found
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>

            <!-- Info Message -->
            <!-- <div class="info-message">
              <v-icon size="16" color="info" class="mr-2">mdi-information-outline</v-icon>
              <span>Selected users will be restricted from chat functionality</span>
            </div> -->
          </div>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          
          <v-btn
            variant="outlined"
            color="#646464"
            class="dialog-action-btn cancel-btn"
            @click="closeadd"
            :disabled="dialog"
          >
            {{ $t("cancel") || "Cancel" }}
          </v-btn>

          <v-btn
            id="button-save-popupadd-blacklist"
            color="error"
            variant="elevated"
            class="dialog-action-btn save-btn"
            @click="AddUserBlacklist"
            :loading="dialog"
            :disabled="!LineUserID || LineUserID.length === 0"
          >
            <img src="@/assets/Icons/new_user_block_outline.png" alt="add" class="mx-2"/>
            Add to Blacklist
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-overlay v-model="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- delete dialog -->
    <v-dialog v-model="showDeleteDialog" max-width="570">
      <v-card class="dialog-card">
        <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #FFF5F2 0%, #FFFFFF 100%);">
          <span class="font-weight-bold" style="color: #C30000 !important;">{{ $t("confirmDeletion")}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 600">
          {{ $t("confirmDeletionUser") }}
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
          <button type="button" class="cancel-btn" @click="closeDeleteDialog" :disabled="deleting">{{ $t("cancel") }}</button>
          <v-btn class="delete-confirm-btn" :loading="deleting" @click="DeleteUserBlacklist(item)">
            <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
            <p style="color: #ffffff; font-weight: 500;">{{ $t("delete") }}</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- warning dialog -->
    <v-dialog v-model="showWarningDialog" max-width="570">
      <v-card class="dialog-card">
        <v-card-title class="card-dialog-title py-4 px-5" style="background: linear-gradient(100deg, #FFF8ED 0%, #FFF0DA 100%);">
          <span class="font-weight-bold" style="color: #C30000 !important;">{{warningTitle}}</span>
          <v-icon
            v-show="showButton"
            size="30"
            class="cursor-pointer float-end"
            @click="closeWarningDialog"
            style="color: black;"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text" style="font-weight: 500">
          {{warningMessage}}
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions v-show="showButton" class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
          <button type="button" class="warning-btn" @click="closeWarningDialog" :disabled="deleting">OK</button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import enurl from '@/api/environment';
import Cookies from "js-cookie";
// import store from '../store';

// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
export default {
  name: "BlacklistChatUserManagement",
  inject: ["flagNav" ,"FontColorTitle","SubNavbarBackGround"],
  mixins: [LogTrace],
  data: () => ({
    // LineUserID: null,
    LineUserID: [],
    dialog: false,
    LineUser: [],
    Adddialog: false,
    isSearch: false,
    userID: "",
    totalTable: 0,
    itemsPerPage: 10,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    today: null,
    userList: [],
    headers: [],
    roleId: Cookies.get("roleId"),
    isFirst: true,
    searchTotalTable: 0,
    sortBy: [],
    sortDesc: [],
    loading: true,
    isFocused: false,
    showSuccess: false,
    SuccessMessage: "",
    showWarningDialog: false,
    showDeleteDialog: false,
    deleting: false,
    warningTitle: "",
    warningMessage: "",
    showButton: true,
    item: null,
    hasSearched: false,
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    Adddialog(val) {
      if (!val) {
        this.clearFields();
      }
    },
  },
  mounted() {
    this.headers = [
      {
        title: this.$t("no"),
        align: "left",
        sortable: false,
      },
      {
        title: this.$t("_userid"),
        align: "left",
        sortable: true,
        value: "userID",
      },
      {
        title: this.$t("_date"),
        align: "left",
        sortable: true,
        value: "createDate",
      },
      {
        title: this.$t("manage"),
        align: "center",
        sortable: false,
      },
    ];
    this.GetDate();
  },
  computed: {
    
    allUsersOptions() {
      return this.LineUser;
    },
    allUsersSelected() {
      return this.LineUser.length > 0 && this.LineUserID.length === this.LineUser.length;
    },
    someUsersSelected() {
      return this.LineUserID.length > 0 && this.LineUserID.length < this.LineUser.length;
    },
    noDataMessage() {
      const hasResults = this.userList.length > 0;
      if (hasResults) {
        return "";
      }

      const userIDQuery = (this.userID || "").trim();

      if (!this.hasSearched || !userIDQuery) {
        return "No data available";
      }

      if (userIDQuery) {
        return `"User ID Was Not Found"`;
      }

      return "No data available";
    }
  },

  methods: {
    toLocal(dateStr) {
      const [date, time] = dateStr.split(' ');
      const [day, month, year] = date.split('/');
      const utcDate = new Date(`${year}-${month}-${day}T${time}Z`);
      
      const localDay = String(utcDate.getDate()).padStart(2, '0');
      const localMonth = String(utcDate.getMonth() + 1).padStart(2, '0');
      const localYear = utcDate.getFullYear();
      const localHours = String(utcDate.getHours()).padStart(2, '0');
      const localMinutes = String(utcDate.getMinutes()).padStart(2, '0');
      const localSeconds = String(utcDate.getSeconds()).padStart(2, '0');
      
      return `${localDay}/${localMonth}/${localYear}\n${localHours}:${localMinutes}:${localSeconds}`;
    },
    openDeleteDialog(item) {
      if (!item) return;
      this.showDeleteDialog = true;
      this.item = item;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.item = null;
    },
    openWarningDialog(title, message, show = true, sec = 3000) {
      this.warningTitle = title;
      this.warningMessage = message;
      this.showWarningDialog = true;
      this.showButton = show;
      if(!show){
        setTimeout(() => {
          this.closeWarningDialog();
        }, sec);
      }
    },
    closeWarningDialog() {
      this.showWarningDialog = false;
      this.warningTitle = "";
      this.warningMessage = "";
    },

    toggleAllUsers() {
      let self = this;
      if (self.allUsersSelected) {
        // Deselect all
        self.LineUserID = [];
      } else {
        // Select all
        self.LineUserID = self.LineUser.map(user => user.userId);
      }
    },
    
    toggleUser(userId) {
      let self = this;
      const index = self.LineUserID.indexOf(userId);
      if (index > -1) {
        // Remove user
        self.LineUserID.splice(index, 1);
      } else {
        // Add user
        self.LineUserID.push(userId);
      }
    },
    deselectAllUsers() {
      let self = this;
      self.LineUserID = [];
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.hasSearched = true;
      self.options.page = 1;
      self.GetSearch();
    },

    clearFields() {
      let self = this;
      self.resetForm();
    },

    resetForm() {
      let self = this;
      // self.LineUserID = null;
      self.LineUserID = [];
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    GetLineUserID() {
      let self = this;
      self.$call.GetLineUserID(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const uniqueUsers = dataResponse.data.filter((user, index, arr) => 
              arr.findIndex(item => 
                item.userId === user.userId && 
                item.displayName === user.displayName
              ) === index
            );
            self.LineUser = uniqueUsers;
          } else {
            self.LineUser = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    async Get() {
      try {
        let self = this;
        self.dialog = true;
        
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === 'desc';
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        await self.$call.GetTableBlacklistChatUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.total > 0) {
                self.searchTotalTable = dataResponse.data.total;
                self.userList = dataResponse.data.data;
                // self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
                self.totalTable = dataResponse.data.total;
              } else {
                self.userList = [];
                self.totalTable = 0;
                self.searchTotalTable = 0;
              }
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
        self.GetLineUserID();
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },

    GetSearch() {
      try {
        let self = this;
        self.dialog = true;
        self.loading = true;
        
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === 'desc';
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          userid: self.userID,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        self.$call.GetTableBlacklistChatUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.total > 0) {
                self.searchTotalTable = dataResponse.data.total;
                self.userList = dataResponse.data.data;
                self.totalTable = self.isFirst
                  ? dataResponse.data.total
                  : self.totalTable;
              } else if (dataResponse.data.data.data == null) {
                self.userList = [];
                self.totalTable = 0;
                self.searchTotalTable = 0;
              }
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },

    DeleteUserBlacklist(val) {
      let self = this;
      try {
        if (self.deleting) return;
        if (self.roleId != "0") {
          self.openWarningDialog(
            "Warning!",
            this.$t("notAuthoritySuperAdmin"),
            false,
            2000
          );
          self.closeDeleteDialog();
          return;
        }
        self.showDeleteDialog = false;
        self.item = null;
        self.dialog = true;
        self.deleting = true;
        let id = val.id ?? val.userID ?? val.userId;
        self.$call.DeleteBlacklistChatUser(
          id,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.totalTable = self.totalTable - 1;
              this.SuccessMessage =  "Successfully Deleted !";
              this.showSuccess = true;
              clearTimeout(this._addToastTimer);
              this._addToastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 4000);
              self.Get();
            } else if (dataResponse.status == 4) {
              self.openWarningDialog(
                  "Warning!",
                  this.$t("oneSuperAdmin"),
                  false,
                  2000
                );
            }
            self.dialog = false;
            self.deleting = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.deleting = false;
            console.error(errorResource);
          }
        );
            
      } catch (error) {
        self.dialog = false;
        self.deleting = false;
        this.LogTrace(error, "DeleteUserBlacklist");
      }
    },

    closeadd() {
      let self = this;
      // self.LineUserID = null;
      self.LineUserID = [];
      self.Adddialog = false;
    },

    async AddUserBlacklist() {
      try {
        let self = this;
        self.dialog = true;
        if (self.LineUserID.length > 0) {
          await self.$call.SetBlacklistChatUser(
            self.LineUserID,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.SuccessMessage =  "Blacklist User Added Successfully !";
                this.showSuccess = true;
                clearTimeout(this._addToastTimer);
                this._addToastTimer = setTimeout(() => {
                  this.showSuccess = false;
                }, 1500);
                self.Adddialog = false;
                self.dialog = false;
                self.totalTable = self.totalTable + self.LineUserID.length;
                // self.LineUserID = null;
                self.LineUserID = [];
                await self.Get();
              } else {
                self.openWarningDialog(
                  "Warning!",
                  dataResponse.data.message,
                  false,
                  1800
                );
              }
              self.LineUserID = [];
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          alert("Please fill all the fields!!!");
          self.Adddialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "AddUserBlacklist");
      }
    },
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.title {
  color: white;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}
.modern-autocomplete :deep(.v-field) {
  border-radius: 8px;
}

.info-icon {
  cursor: help;
  transition: all 0.2s ease;
}

.info-icon:hover {
  color: #1976d2 !important;
  transform: scale(1.1);
}
/* No Data Template */
.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 40px 20px;
}

.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 400px;
  gap: 24px;
}

.no-data-icon {
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.no-data-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.no-data-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #424242;
  margin: 0;
  letter-spacing: 0.025em;
}

.no-data-subtitle {
  font-size: 0.9rem;
  color: #757575;
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
}

.no-data-btn {
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.025em;
  min-width: 140px;
  height: 40px;
}

.no-data-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}/* Dialog Styling */
.modern-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

/* redesign style */
.subTitleStyle :deep(.v-toolbar__content) {
  height: auto !important;
}
.subTitleStyle :deep(.v-toolbar-title__placeholder) {
  font-weight: 600 !important;
  max-width: 370px;
}

.searchInput{
  width: clamp(200px, 300px, 400px) !important;
}
.searchInput :deep(.v-input__control .v-field) {
  border-radius: 16px !important;
  background-color: white !important;
  display: flex;
  padding: 8px 16px;
  align-items: center;
  height: 52px !important;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
}
.searchInput :deep(.v-field__input) {
  padding: 0 !important;
}

.create-btn {
  display: flex;
  height: 52px !important;
  margin: 0px !important;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px !important;
  border: 1px solid #C32E0E;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  color: white !important;
  box-shadow: none;
}
.create-btn:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.create-btn :deep(.v-btn__content span) {
  font-weight: 500 !important;
  font-size: 1.1rem;
}

::v-deep .v-data-table__wrapper {
  margin-bottom: 0;
}
.v-table :deep(.v-data-table__th) {
  border-bottom: none !important;
}
.v-table :deep(.v-data-table__thead tr th:first-child) {
  border-radius: 16px 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:last-child) {
  border-radius: 0 16px 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:not(:first-child):not(:last-child)) {
  border-radius: 0 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table-header__content span) {
  font-weight: 600 !important;
}
.v-table :deep(.v-data-table__tbody tr td){
  border-bottom: 1px solid #E1E1E1 !important;
}
.v-table :deep(.v-data-table__tbody tr):hover {
  background: #FFFCFC;
}
.v-table :deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon) {
  color: #872612;
  opacity: 1 !important;
}
.table-cell{
  max-width: 200px !important;
}

.dialog-card {
  border-radius: 12px !important;
}
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #2ABF56 0%, #135928 100%) !important;
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 700px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}

.info-icon:hover {
  color: #9e9e9e !important;
  cursor: unset;
}

/* Header */
.dialog-header {
  /* background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%); */
  color: white;
  padding: 24px 32px 12px !important;
  /* border-bottom: none; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  flex: 1;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: white;
  line-height: 1.2;
}

.dialog-subtitle {
  font-size: 0.875rem;
  margin: 4px 0 0 0;
  opacity: 0.9;
  color: white;
  font-weight: 400;
}

/* Content */
.dialog-content {
  padding: 32px !important;
  background: #fafafa;
}

.input-section {
  background: white;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
}

.required-asterisk {
  color: #d32f2f;
  margin-left: 4px;
  font-weight: 700;
}

.modern-autocomplete :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-autocomplete :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(211, 47, 47, 0.2);
}

.modern-autocomplete :deep(.v-chip) {
  padding: 5px 10px !important;
  height: auto;
}
.modern-autocomplete :deep(.v-chip__close) {
  border-left: 1px solid #CCCCCC;
  padding-left: 3px;
  margin-right: 3px;
}
.modern-autocomplete :deep(.v-autocomplete__menu-icon) {
  color: #872612;
  font-size: 32px;
  opacity: 1;
}

.user-chip {
  margin: 2px 4px 2px 0 !important;
  font-weight: 500 !important;
  color: #C30000 !important;
}

.autocomplete-item {
  height: 70px !important;
}
.autocomplete-item:hover {
  background: rgba(211, 47, 47, 0.04) !important;
}

.info-message {
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 12px 16px;
  background: rgba(33, 150, 243, 0.08);
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 0.875rem;
  color: #1565c0;
}

/* Actions */
.dialog-actions {
  padding: 24px 32px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  gap: 12px;
}

.dialog-action-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  min-width: 120px;
  height: 44px !important;
  font-size: 0.9rem !important;
}

.cancel-btn {
  color: #646464 !important;
  border-color: #949AA8 !important;
  border-radius: 16px !important;
}

.cancel-btn:hover {
  background: rgba(117, 117, 117, 0.04) !important;
  border-color: #bdbdbd !important;
  transform: none !important;
}

.save-btn {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%);
  /* box-shadow: 0 4px 12px rgba(211, 47, 47, 0.3) !important; */
  border-radius: 16px !important;
}

.save-btn:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%);
  /* box-shadow: 0 6px 16px rgba(211, 47, 47, 0.4) !important; */
  /* transform: translateY(-1px); */
  transform: none !important;
  box-shadow: none !important;
}

.save-btn:disabled {
  opacity: 0.6 !important;
  transform: none !important;
  box-shadow: none !important;
}

/* All Users Selection */
.all-users-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.293);
}

.autocomplete-item {
  margin-top: 8px;
  transition: background 0.2s ease;
  cursor: pointer;
}

.no-data-placeholder {
  padding: 16px 0;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
}

/* Responsive */
@media (max-width: 600px) {
  .dialog-header {
    padding: 20px 24px !important;
  }
  
  .dialog-content {
    padding: 24px !important;
  }
  
  .input-section {
    padding: 20px;
  }
  
  .dialog-actions {
    padding: 20px 24px !important;
    flex-direction: column-reverse;
  }
  
  .dialog-action-btn {
    width: 100%;
    margin: 4px 0 !important;
  }
}
</style>
